import * as React from 'react';

const SvgAdjustmentsHorizontalSolid = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M9.472 8.694a2.25 2.25 0 0 0 2.248-2.25 2.249 2.249 0 1 0-2.248 2.25m2.996-2.25a.75.75 0 0 1 .75-.75h7.494a.75.75 0 1 1 0 1.5h-7.494a.75.75 0 0 1-.75-.75m-8.992 0a.75.75 0 0 1 .75-.75h1.499a.75.75 0 1 1 0 1.5H4.226a.75.75 0 0 1-.75-.75m0 12a.75.75 0 0 1 .75-.75h1.499a.75.75 0 1 1 0 1.5H4.226a.75.75 0 0 1-.75-.75m17.236-5.25a.75.75 0 0 0 0-1.5h-1.499a.75.75 0 0 0 0 1.5zm-7.494 4.5a.75.75 0 1 0 0 1.5h7.494a.75.75 0 1 0 0-1.5zm-.748-5.25a.75.75 0 0 1-.75.75H4.226a.75.75 0 0 1 0-1.5h7.494a.75.75 0 0 1 .75.75m-2.998 8.25a2.25 2.25 0 1 0-.002-4.498 2.25 2.25 0 0 0 .002 4.498m8.242-8.25a2.249 2.249 0 1 1-2.248-2.25 2.25 2.25 0 0 1 2.248 2.25"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgAdjustmentsHorizontalSolid;
